import { Redirect, useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function CommunityRedirectScreen() {
  const { communitySlug, ...params } = useLocalSearchParams<{
    communitySlug: string;
  }>();

  if (!communitySlug) {
    return <Redirect href={{ pathname: '/communities', params }} />;
  }

  return (
    <Redirect
      href={{
        pathname: `/communities/${communitySlug}`,
        params,
      }}
    />
  );
}
